const PointOfViewSectionBottomContent = () => {
  const sectionContents = [
    {
      title: "Channel Partner benefits",
      underlineColorClass: "bg-secondary-light",
      content: `We provide leading-edge tracking systems, technology integrations, ancillary expansion 
      opportunities and rev-share options. 
      Let’s review your position and find a starting place.`,
    },
    {
      title: "Qualities we look for",
      underlineColorClass: "bg-primary-light",
      content: `We’re looking for specific qualities in channel partners. 
      Does your company provide reliable volume and margin? 
      Do you engage your customers with new partner programs?`,
    },
  ];

  return (
    <div className="flex flex-col-reverse lg:grid lg:grid-cols-12 2xl:w-2/3 overflow-hidden">
      <div className="mt-16 lg:mt-0 lg:col-span-5 flex justify-start">
        <div
          className="min-h-[756px] rounded-2xl h-full w-full bg-cover bg-right-top bg-no-repeat"
          style={{
            backgroundImage: "url('/images/partners/point-of-view-02.png')",
          }}
        />
      </div>
      <div className="lg:col-span-7 flex flex-col items-center justify-center">
        <div className="flex flex-col items-start justify-center lg:p-16">
          <span className="label-lg mb-4">Become a partner.</span>
          <div className="flex flex-col space-y-10 lg:space-y-20">
            {sectionContents.map((content) => (
              <div key={content.title} className="flex flex-col space-y-5">
                <span className="mobile-h3 md:h5 lg:h3">{content.title}</span>
                <div
                  className={`h-2 w-[200px] ${content.underlineColorClass}`}
                />
                <span className="subheading">{content.content}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointOfViewSectionBottomContent;
